import '@babel/polyfill';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';

import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV !== 'development') {
	Sentry.init({
		dsn: process.env.VUE_APP_SENTRY_DSN,
		integrations: [new Sentry.Integrations.Vue({ Vue })],
		environment: process.env.NODE_ENV,
		release: require('../package.json').version,
	});
}

import router from './router';
import store from './store';

import '@/globals';
import '@/plugins';

window.tmVue = new Vue({
	router,
	store,
	...App,
}).$mount('#app');
